// src/components/InstallPrompt/usePWAInstallPrompt.js
import { useEffect, useState } from "react";
import dayjs from "dayjs";

export default function usePWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("pwaPromptDismissed");
    if (dismissed && dayjs().isBefore(dayjs(dismissed).add(7, "day"))) {
      return; // Don't show prompt yet
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const triggerInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        console.log("User accepted install");
      } else {
        console.log("User dismissed install");
      }
      localStorage.setItem("pwaPromptDismissed", dayjs().toISOString());
      setDeferredPrompt(null);
      setCanInstall(false);
    }
  };

  const dismissPrompt = () => {
    localStorage.setItem("pwaPromptDismissed", dayjs().toISOString());
    setCanInstall(false);
  };

  return { canInstall, triggerInstall, dismissPrompt };
}
